import { render, staticRenderFns } from "./aiImgsInfoModule.vue?vue&type=template&id=015ffefc&scoped=true"
import script from "./aiImgsInfoModule.vue?vue&type=script&lang=js"
export * from "./aiImgsInfoModule.vue?vue&type=script&lang=js"
import style0 from "./aiImgsInfoModule.vue?vue&type=style&index=0&id=015ffefc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ffefc",
  null
  
)

export default component.exports